module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/evaluate/assets/arrow-right-black.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/evaluate/assets/arrow-right-black.png
// module id = 1929
// module chunks = 367